import { FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StatsPickerFormControl = styled(FormControl)`
  width: 250px;
`;
